import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { Simulation, StepName } from 'src/app/models';
import { SimulationService } from 'src/app/services';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-count-down',
  templateUrl: './count-down.component.html',
  styleUrls: ['./count-down.component.css'],
})
export class CountDownComponent implements OnInit, OnDestroy {
  @Input() juez: boolean = false;
  @Input() idSimulation!: string;
  @Input() step!: StepName;
  @Input() limiteDias!: number;
  @Input() secundario: boolean = false;

  @Output() fueraDeHorario = new EventEmitter<boolean>();
  fueraHorario: boolean = false;

  horarioDisponibilidad: { inicio: number; fin: number } = {
    inicio: 8,
    fin: 17,
  };
  intervalo: any;

  simulacion!: Simulation;
  dateStepStart!: Date;
  dateStepEnd!: Date;
  dateStepStop?: Date | number | string;

  disabled: boolean = false;
  nroDias!: number;
  stopped: boolean = false;

  // ✅ FIX: inicializar con valores por defecto para evitar crash en el template
  tiempoRestante: {
    dias: number;
    horas: number;
    minutos: number;
    segundos: number;
  } = { dias: 0, horas: 0, minutos: 0, segundos: 0 };

  diasRestantes!: number;

  constructor(
    private simulationService: SimulationService,
    private activatedRoute: ActivatedRoute
  ) {}

  // ✅ FIX: obtener la hora actual ajustada a Ecuador (UTC-5)
  private ahoraEnEcuador(): Date {
    const now = new Date();
    // Offset de Ecuador: UTC-5 = -300 minutos
    const offsetEcuador = -5 * 60;
    const offsetLocal = now.getTimezoneOffset(); // en minutos, positivo si detrás de UTC
    const diff = (offsetEcuador - (-offsetLocal)) * 60 * 1000;
    return new Date(now.getTime() + diff);
  }

  ngOnInit(): void {
    this.activatedRoute.parent?.params
      .pipe(
        switchMap(({ id }) =>
          this.simulationService.watchSimulationByIdentifier(id)
        )
      )
      .subscribe((result) => {
        clearInterval(this.intervalo);
        this.simulacion = result as Simulation;

        const stepActual = this.simulacion.steps?.find(
          (step) => step.name === this.step
        );

        this.fueraDeHorario.emit(false);
        if (this.secundario) {
          this.dateStepStart = new Date(stepActual?.start_date2!);
          this.dateStepEnd = new Date(stepActual?.end_date2!);
        } else {
          this.dateStepStart = new Date(stepActual?.start_date!);
          this.dateStepEnd = new Date(stepActual?.end_date!);
        }

        if (this.step === 'Pruebas') {
          if (!!stepActual?.document && !!stepActual.document2) {
            if (stepActual.stop_date! > stepActual.stop_date2!) {
              this.dateStepStop = stepActual?.stop_date;
            } else {
              this.dateStepStop = stepActual?.stop_date2;
            }
          }
        } else if (
          this.step === 'Apelación' ||
          this.step === 'Apelación de providencias preventivas'
        ) {
          if (stepActual?.stop_date && stepActual.stop_date2) {
            this.dateStepStop =
              stepActual.stop_date > stepActual.stop_date2
                ? stepActual.stop_date
                : stepActual.stop_date2;
          } else if (!stepActual?.stop_date) {
            this.dateStepStop = stepActual?.stop_date;
          } else if (!stepActual?.stop_date2) {
            this.dateStepStop = stepActual?.stop_date2;
          }
        } else if (this.step === 'Providencia de sustanciación') {
          if (this.secundario) {
            this.dateStepStop = stepActual?.stop_date;
          } else {
            this.dateStepStop = stepActual?.stop_date2;
          }
        } else if (this.step === 'Argumentos de contraparte') {
          if (this.secundario) {
            this.dateStepStop = stepActual?.stop_date2;
          } else {
            this.dateStepStop = stepActual?.stop_date;
          }
        } else if (this.step === 'Auto interlocutorio sobre prueba nueva') {
          if (this.secundario && stepActual?.stop_date2) {
            this.dateStepStop = stepActual?.stop_date2;
          } else if (!this.secundario && stepActual?.stop_date) {
            this.dateStepStop = stepActual?.stop_date;
          }
        } else if (!this.secundario) {
          if (stepActual?.stop_date) {
            this.stopped = true;
          }
          this.dateStepStop = stepActual?.stop_date;
        }

        console.log(stepActual);
        console.log(this.dateStepStart, 'dateStepStart');
        console.log(this.dateStepEnd, 'dateStepEnd');

        if (this.step === 'Pruebas') {
          if (stepActual?.status === 'missing') {
            this.fueraDeHorario.emit(true);
            this.fueraHorario = true;
            this.calcularTiempoDetenido(
              new Date(this.dateStepStop!),
              this.dateStepEnd
            );
          } else {
            this.calcularTiempoRestante();
            if (this.ahoraEnEcuador().getTime() > this.dateStepEnd.getTime()) {
              this.tiempoRestante = { dias: 0, horas: 0, minutos: 0, segundos: 0 };
              this.stopped = true;
            } else {
              this.intervalo = setInterval(() => {
                this.calcularTiempoRestante();
              }, 1000);
            }
          }
        } else if (
          // ✅ FIX: comparar fechas completas, no solo getDate() que solo compara día del mes
          this.dateStepStart.getTime() > this.ahoraEnEcuador().getTime() &&
          !this.dateStepStop
        ) {
          this.fueraHorario = true;
          this.fueraDeHorario.emit(true);
        } else {
          this.fueraDeHorario.emit(false);
          this.fueraHorario = false;

          if (
            (this.step === 'Apelación' ||
              this.step === 'Apelación de providencias preventivas') &&
            stepActual?.stop_date &&
            stepActual?.stop_date2
          ) {
            this.calcularTiempoDetenido(new Date(this.dateStepStop!), this.dateStepEnd);
            this.stopped = true;
            this.fueraHorario = false;
          } else if (
            this.step === 'Providencia de sustanciación' &&
            stepActual?.stop_date2 &&
            !this.secundario
          ) {
            this.calcularTiempoDetenido(new Date(this.dateStepStop!), this.dateStepEnd);
            this.stopped = true;
            this.fueraHorario = false;
          } else if (
            this.step === 'Providencia de sustanciación' &&
            stepActual?.stop_date &&
            this.secundario
          ) {
            this.calcularTiempoDetenido(new Date(this.dateStepStop!), this.dateStepEnd);
            this.stopped = true;
            this.fueraHorario = false;
          } else if (
            this.step === 'Argumentos de contraparte' &&
            stepActual?.stop_date &&
            !this.secundario
          ) {
            this.calcularTiempoDetenido(new Date(this.dateStepStop!), this.dateStepEnd);
            this.stopped = true;
            this.fueraHorario = false;
          } else if (
            this.step === 'Argumentos de contraparte' &&
            stepActual?.stop_date2 &&
            this.secundario
          ) {
            this.calcularTiempoDetenido(new Date(this.dateStepStop!), this.dateStepEnd);
            this.stopped = true;
            this.fueraHorario = false;
          } else if (
            this.step === 'Auto interlocutorio sobre prueba nueva' &&
            stepActual?.stop_date &&
            !this.secundario
          ) {
            this.calcularTiempoDetenido(new Date(this.dateStepStop!), this.dateStepEnd);
            this.stopped = true;
            this.fueraHorario = false;
          } else if (
            this.step === 'Auto interlocutorio sobre prueba nueva' &&
            stepActual?.stop_date2 &&
            this.secundario
          ) {
            this.calcularTiempoDetenido(new Date(this.dateStepStop!), this.dateStepEnd);
            this.stopped = true;
            this.fueraHorario = false;
          } else if (stepActual?.stop_date && !this.secundario) {
            this.calcularTiempoDetenido(new Date(this.dateStepStop!), this.dateStepEnd);
            this.stopped = true;
            this.fueraHorario = false;
          } else {
            this.calcularTiempoRestante();
            if (this.ahoraEnEcuador().getTime() > this.dateStepEnd.getTime()) {
              this.tiempoRestante = { dias: 0, horas: 0, minutos: 0, segundos: 0 };
              this.stopped = true;
            } else {
              this.intervalo = setInterval(() => {
                this.calcularTiempoRestante();
              }, 1000);
            }
          }
        }
      });
  }

  calcularTiempoDetenido(dateStop: Date, dateEnd: Date) {
    if (dateStop.getTime() > dateEnd.getTime()) {
      this.tiempoRestante = { dias: 0, horas: 0, minutos: 0, segundos: 0 };
    } else {
      let dias = Math.floor(
        (dateEnd.getTime() - dateStop.getTime()) / (1000 * 60 * 60 * 24)
      );
      let horas = this.horarioDisponibilidad.fin - dateStop.getHours() - 1;
      let minutos = 59 - dateStop.getMinutes();
      let segundos = 59 - dateStop.getSeconds();
      this.tiempoRestante = { dias, horas, minutos, segundos };
    }
  }

  calcularTiempoRestante() {
    // ✅ FIX: usar hora de Ecuador en todos los cálculos
    let now = this.ahoraEnEcuador();

    let hoyInicio = this.ahoraEnEcuador();
    hoyInicio.setHours(this.horarioDisponibilidad.inicio, 0, 0, 0);

    let hoyFin = this.ahoraEnEcuador();
    hoyFin.setHours(this.horarioDisponibilidad.fin - 1, 59, 59, 0);

    if (this.dateStepStop) {
      this.calcularTiempoDetenido(new Date(this.dateStepStop!), this.dateStepEnd);
      this.fueraHorario = false;
    } else if (now >= hoyInicio && now <= hoyFin) {
      this.fueraHorario = false;
      let tiempoRestanteMS = hoyFin.getTime() - now.getTime();

      if (tiempoRestanteMS > 0) {
        let dias = Math.floor(
          (this.dateStepEnd.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
        );
        let horas = Math.floor(
          (tiempoRestanteMS % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        let minutos = Math.floor(
          (tiempoRestanteMS % (1000 * 60 * 60)) / (1000 * 60)
        );
        let segundos = Math.floor((tiempoRestanteMS % (1000 * 60)) / 1000);
        this.tiempoRestante = { dias, horas, minutos, segundos };
      }
    } else {
      console.warn('fuera de horario');
      // ✅ FIX: asignar tiempoRestante antes de emitir para evitar crash en template
      this.tiempoRestante = { dias: 0, horas: 0, minutos: 0, segundos: 0 };
      this.fueraDeHorario.emit(true);
      this.fueraHorario = true;
    }
  }

  aumentarTiempo() {
    const index = this.simulacion.steps?.findIndex(
      (step) => step.name === this.step
    );
    if (index === undefined || index < 0) return;

    if (!this.dateStepStop) {
      const newDate = this.dateStepEnd.getTime() + 24 * 60 * 60 * 1000;
      this.dateStepEnd = new Date(newDate);
      if (!this.secundario) {
        this.simulacion.steps![index].end_date = newDate;
      } else {
        this.simulacion.steps![index].end_date2 = newDate;
      }
      clearInterval(this.intervalo);
      this.calcularTiempoRestante();
      this.intervalo = setInterval(() => this.calcularTiempoRestante(), 1000);
      this.simulationService.putSimulation(this.simulacion).subscribe();
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'No se puede agregar más el tiempo',
      });
    }
  }

  disminuirTiempo() {
    const index = this.simulacion.steps?.findIndex(
      (step) => step.name === this.step
    );
    if (index === undefined || index < 0 || this.stopped) return;

    if (
      this.dateStepEnd.getTime() >
        this.dateStepStart.getTime() + this.limiteDias * 24 * 60 * 60 * 1000 &&
      this.tiempoRestante.dias >= 1
    ) {
      const newDate = this.dateStepEnd.getTime() - 24 * 60 * 60 * 1000;
      this.dateStepEnd = new Date(newDate);
      if (!this.secundario) {
        this.simulacion.steps![index].end_date = newDate;
      } else {
        this.simulacion.steps![index].end_date2 = newDate;
      }
      clearInterval(this.intervalo);
      this.calcularTiempoRestante();
      this.intervalo = setInterval(() => this.calcularTiempoRestante(), 1000);
      this.simulationService.putSimulation(this.simulacion).subscribe();
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'No se puede disminuir más el tiempo',
      });
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalo);
  }
}
